<template lang="pug">
base-dialog(
  :value="value",
  @input="$emit('input', $event)",
  :titulo="titulo",
  :max-width="maxWidth",
  scrollable,
  :mostrar-confirmar="false",
  texto-cancelar="Fechar"
)
  .preview-actions.d-flex.align-center.gap-2.mt-0(v-if="comBusca")
    v-text-field.preview-field.preview-search(
      :value="filtro",
      @input="$emit('update:filtro', $event)",
      prepend-inner-icon="mdi-magnify",
      :placeholder="placeholderBusca",
      clearable,
      hide-details,
      filled,
      rounded,
      dense
    )

  .preview-conteudo.mt-2
    v-progress-linear(v-if="carregando", indeterminate, color="blue", height="2")
    .preview-empty.text-center.py-6(v-else-if="vazio")
      v-icon.empty-state-icon(size="40", :color="corIconeVazio") {{ iconeVazio }}
      .empty-state-subtitle.mt-2 {{ textoVazio }}
    slot(v-else)

  //- Ações opcionais abaixo do conteúdo (ex.: expandir/recolher)
  slot(name="rodape-conteudo")
</template>

<script>
import BaseDialog from "./BaseDialog";

export default {
  name: "PreviewDialog",

  components: {
    BaseDialog
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: "Preview"
    },
    comBusca: {
      type: Boolean,
      default: true
    },
    filtro: {
      type: String,
      default: ""
    },
    placeholderBusca: {
      type: String,
      default: "Pesquisar..."
    },
    carregando: {
      type: Boolean,
      default: false
    },
    vazio: {
      type: Boolean,
      default: false
    },
    iconeVazio: {
      type: String,
      default: "mdi-file-tree-outline"
    },
    corIconeVazio: {
      type: String,
      default: "blue lighten-3"
    },
    textoVazio: {
      type: String,
      default: "Nenhum item encontrado"
    },
    maxWidth: {
      type: [String, Number],
      default: 700
    }
  }
};
</script>

<style scoped>
.gap-2 {
  gap: 8px;
}

.preview-actions {
  width: 100%;
}

.preview-search {
  width: 100%;
}

.preview-conteudo {
  height: 400px;
  min-height: 400px;
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;
  border: 1px solid #e0e4ec;
  border-radius: 8px;
  padding: 8px;
  background-color: #fafbfc;
  display: flex;
  flex-direction: column;
}

.preview-empty {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-state-icon {
  opacity: 0.6;
}

.empty-state-subtitle {
  font-size: 12px;
  color: #777;
  max-width: 260px;
  margin: 0 auto;
  line-height: 1.4;
}

/* Campo de busca padrão */
.preview-field {
  border-radius: 6px !important;
  background-color: #fff;
}

.preview-field.v-input--is-focused .v-input__slot {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.15);
}

.preview-field .v-input__slot:hover {
  border-color: #b1bac4;
}

.preview-field .v-input__slot,
.preview-field .v-text-field__slot input {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  min-height: 36px !important;
}

.preview-field .v-input__prepend-inner .v-icon,
.preview-field .v-input__append-inner .v-icon {
  color: #57606a;
  font-size: 18px;
}
</style>
